import { CheckCircle2, Info, Eye, EyeOff } from "lucide-react";
import { useState } from "react";
import { Spotlight } from "../components/animations/Spotlight";
import { Container } from "../components/ui/container";
import { Input } from "../components/ui/input";
import { Logo } from "../components/ui/logo";
import { BottomGradient } from "./botton";
import { LabelInputContainer } from "./label";
import { motion } from "framer-motion";
import { TextGenerateEffect } from "../components/animations/text-generate-effect";

const LoginForm = ({ onSuccess, productId }) => {
  const [isLogin, setIsLogin] = useState(true);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [acceptTerms, setAcceptTerms] = useState(false); // New state for terms checkbox
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const response = await fetch(window.siteUrl + "/wp-json/custom/v1/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ username, password }),
    });
    const data = await response.json();
    setIsLoading(false);
    if (response.ok) {
      window.isLogin = true;
      setSuccessMessage("Login successful!");
      setErrorMessage("");
      if (onSuccess) {
        onSuccess();
      } else {
        if (window.isLocalhost) window.location.href = "/wordpress/my-account/";
        else window.location.href = "/my-account/";
      }
    } else {
      setErrorMessage(data.message || "Login failed.");
      setSuccessMessage("");
    }
  };

  const handleRegistration = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    // Check if terms are accepted
    if (!acceptTerms) {
      setErrorMessage("Please accept the terms and conditions to continue.");
      setSuccessMessage("");
      setIsLoading(false);
      return;
    }
    
    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match.");
      setSuccessMessage("");
      setIsLoading(false);
      return;
    }
    
    const response = await fetch(
      window.siteUrl + "/wp-json/wp/v2/users/register",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, email, password }),
      }
    );
    const data = await response.json();
    setIsLoading(false);
    if (response.ok) {
      window.isLogin = true;
      setIsLogin(true);
      setSuccessMessage("Registration successful! You can now log in.");
      setErrorMessage("");
      // if (onSuccess) {
      //   onSuccess();
      // } else {
      //   window.location.href = "/wordpress/my-account/";
      // }
    } else {
      setErrorMessage(data.message || "Registration failed.");
      setSuccessMessage("");
    }
  };

  function openPopup() {
    if (productId) localStorage.setItem("productId", productId);

    const width = 600;
    const height = 400;
    const left = (screen.width - width) / 2;
    const top = (screen.height - height) / 2;

    const params = `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`;

    const popupWindow = onSuccess
      ? window.open(
          "https://whizmanage.com/wp-login.php?loginSocial=google",
          "_blank",
          params
        )
      : window.open(
          "https://whizmanage.com/wp-login.php?loginSocial=google&redirect=https%3A%2F%2Fwhizmanage.com%2Flogin%2F",
          "_blank",
          params
        );

    function isSameBaseURL(urlWithParams, baseUrl) {
      const url1 = new URL(urlWithParams);
      const url2 = new URL(baseUrl);

      // Compare the origin and pathname of both URLs
      return url1.origin + url1.pathname === url2.origin + url2.pathname;
    }

    const baseUrl = "https://whizmanage.com/my-account/";

    const popupChecker = setInterval(() => {
      console.log(popupWindow.location.href);
      if (popupWindow.closed !== false) {
        clearInterval(popupChecker);
        window.location.reload();
      } else {
        if (isSameBaseURL(popupWindow.location.href, baseUrl)) {
          // window.isLogin = true;
          clearInterval(popupChecker);
          popupWindow.close();
          // onSuccess();
          // location.reload();
        }
      }
    }, 500);
  }

  return (
    <Container className="max-w-lg mx-auto flex flex-col items-center justify-center">
      <div className="h-36 flex justify-center text-center items-center">
        {successMessage && (
          <p className="text-xl flex gap-2 items-center text-green-600">
            <CheckCircle2 className="size-6 mt-4" />
            <TextGenerateEffect
              duration={2}
              filter={false}
              words={successMessage}
            />
            {/* <span>{successMessage}</span> */}
          </p>
        )}
      </div>
      <Logo />
      <h1 className="text-xl md:text-4xl font-bold my-4 text-white">
        Welcome to Whizmanage
      </h1>
      <Spotlight
        className="-top-40 left-0 md:left-60 md:-top-20"
        fill="white"
      />
      {isLogin ? (
        <form className="my-8 w-full" onSubmit={handleLogin}>
          <LabelInputContainer className="mb-4">
            <Input
              placeholder="Username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </LabelInputContainer>
          <LabelInputContainer className="mb-4 relative">
            <Input
              placeholder="Password"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              className="absolute right-4 top-2 text-gray-500"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
            </button>
          </LabelInputContainer>
          <a
            href={window.siteUrl + "/password-reset/"}
            className="!text-fuchsia-600"
          >
            Forgot Password?
          </a>
          {errorMessage && (
            <p className="!text-pink-600 flex gap-2 items-center mt-2">
              <Info className="size-4" />
              <span>{errorMessage}</span>
            </p>
          )}
          <button
            className="bg-gradient-to-br text-lg relative group/btn from-black dark:from-zinc-900 dark:to-zinc-900 to-neutral-600 block dark:bg-zinc-800 w-full text-white rounded-md h-10 font-medium shadow-[0px_1px_0px_0px_#ffffff40_inset,0px_-1px_0px_0px_#ffffff40_inset] dark:shadow-[0px_1px_0px_0px_var(--zinc-800)_inset,0px_-1px_0px_0px_var(--zinc-800)_inset]"
            type="submit"
          >
            Login &rarr;
            <BottomGradient />
          </button>
          <div className="bg-gradient-to-r from-transparent via-neutral-300 dark:via-neutral-700 to-transparent my-8 h-[1px] w-full" />
          <div className="flex flex-col space-y-4">
            <div
              className="relative group/btn flex space-x-2 items-center justify-center px-4 w-full text-black rounded-md h-10 font-medium shadow-input bg-gray-50 dark:bg-zinc-900 dark:!shadow-[0px_0px_1px_1px_var(--neutral-800)] cursor-pointer"
              // href="https://whizmanage.com/wp-login.php?loginSocial=google&redirect=https%3A%2F%2Fwhizmanage.com%2Flogin%2F"
              onClick={() => openPopup()}
            >
              <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/></svg>
              <span className="text-neutral-700 dark:text-white text-lg">
                Google
              </span>
              <BottomGradient />
            </div>
          </div>
          <p className="mt-4 text-sm text-center text-white">
            Don't have an account?{" "}
            <span
              className="text-fuchsia-600 cursor-pointer"
              onClick={() => setIsLogin(false)}
            >
              Register here
            </span>
          </p>
        </form>
      ) : (
        <form className="my-8 w-full" onSubmit={handleRegistration}>
          <LabelInputContainer className="mb-4">
            <Input
              placeholder="Username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </LabelInputContainer>
          <LabelInputContainer className="mb-4">
            <Input
              placeholder="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </LabelInputContainer>
          <LabelInputContainer className="mb-4 relative">
            <Input
              placeholder="Password"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              className="absolute right-4 top-2 text-gray-500"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
            </button>
          </LabelInputContainer>
          <LabelInputContainer className="mb-4 relative">
            <Input
              placeholder="Confirm Password"
              type={showPassword ? "text" : "password"}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            <button
              type="button"
              className="absolute right-4 top-2 text-gray-500"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
            </button>
          </LabelInputContainer>
          
          {/* Terms and Conditions Checkbox */}
          <div className="mb-6 flex items-start gap-3">
            <input
              type="checkbox"
              id="acceptTerms"
              checked={acceptTerms}
              onChange={(e) => setAcceptTerms(e.target.checked)}
              className="mt-1 h-4 w-4 rounded border-gray-300 text-fuchsia-600 focus:ring-fuchsia-500 cursor-pointer checked:!bg-pink-500"
              required
            />
            <label htmlFor="acceptTerms" className="text-sm text-gray-300">
              I agree to the{" "}
              <a
                href="https://docs.whizmanage.com/en/docs/terms-conditions"
                target="_blank"
                rel="noopener noreferrer"
                className="text-fuchsia-600 hover:text-fuchsia-500 underline"
              >
                Terms and Conditions
              </a>
              <span className="text-pink-500 ml-1">*</span>
            </label>
          </div>
          
          {errorMessage && (
            <p className="!text-pink-600 flex gap-2 items-center mt-2 mb-4">
              <Info className="size-4" />
              <span>{errorMessage}</span>
            </p>
          )}
          <button
            className="bg-gradient-to-br relative group/btn from-black dark:from-zinc-900 dark:to-zinc-900 to-neutral-600 block dark:bg-zinc-800 w-full text-white rounded-md h-10 font-medium shadow-[0px_1px_0px_0px_#ffffff40_inset,0px_-1px_0px_0px_#ffffff40_inset] dark:shadow-[0px_1px_0px_0px_var(--zinc-800)_inset,0px_-1px_0px_0px_var(--zinc-800)_inset]"
            type="submit"
          >
            Register &rarr;
            <BottomGradient />
          </button>
          <div className="bg-gradient-to-r from-transparent via-neutral-300 dark:via-neutral-700 to-transparent my-8 h-[1px] w-full" />
          <div className="flex flex-col space-y-4">
            <div
              className="relative group/btn flex space-x-2 items-center justify-center px-4 w-full text-black rounded-md h-10 font-medium shadow-input bg-gray-50 dark:bg-zinc-900 dark:shadow-[0px_0px_1px_1px_var(--neutral-800)] cursor-pointer"
              // href="https://whizmanage.com/wp-login.php?loginSocial=google&redirect=https%3A%2F%2Fwhizmanage.com%2Flogin%2F"
              onClick={() =>
                openPopup(
                  "https://whizmanage.com/wp-login.php?loginSocial=google&redirect=https%3A%2F%2Fwhizmanage.com%2Flogin%2F"
                )
              }
            >
              <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/></svg>
              <span className="text-neutral-700 dark:text-neutral-300 text-lg">
                Google
              </span>
              <BottomGradient />
            </div>
          </div>
          <p className="mt-4 text-sm text-center text-white">
            Already have an account?{" "}
            <span
              className="text-fuchsia-600 cursor-pointer"
              onClick={() => setIsLogin(true)}
            >
              Login here
            </span>
          </p>
        </form>
      )}
      {isLoading && (
        <div className="bg-black/30 fixed inset-0 flex justify-center z-50 items-center">
          <motion.div
            className="h-20 w-20 flex justify-center items-center"
            animate={{
              scale: [1, 2, 2, 1, 1],
              rotate: [0, 0, 180, 180, 0],
            }}
            transition={{
              duration: 2,
              ease: "easeInOut",
              times: [0, 0.2, 0.5, 0.8, 1],
              repeat: Infinity,
              repeatDelay: 1,
            }}
          >
            <img
              src={
                window.siteUrl +
                "/wp-content/plugins/innovative-design/public/logo/symbol.svg"
              }
              alt="logo"
            />
          </motion.div>
        </div>
      )}
    </Container>
  );
};

export default LoginForm;